/* eslint-disable import/prefer-default-export */
export const NUMBER_OF_ROWS = 30;
export const DEFAULT_ROW_HEIGHT = 65;
